import React from "react"
import styled from 'styled-components'

const About = () => {
  return (
    <StyledWrapper>
      <H2><span>About</span> me &#128293;</H2>
      <Paragraph>I am the third year <span>Automatics and Robotics</span> student at AGH UST.</Paragraph>
      <Paragraph>Right now I am a member of the software section at students research club AGH Space Systems.</Paragraph>
      <Paragraph>I am looking for an <span>internship</span> or a job as a <span>working student</span>. I am passionate about <span>machine learning, software development, coding, creating web apps</span>
        In my free time I used to train swimming.</Paragraph>
    </StyledWrapper>
  )
}

const StyledWrapper = styled.div`
  max-width: 520px;
`

const H2 = styled.h2`
  font-weight: ${({theme}) => theme.font.semiBold};
  font-size: 30px;
  color: ${({theme}) => theme.color.black};
  position: relative;
  margin-bottom: 4px;
  
  span::before {
    position: absolute;
    bottom: 0;
    left: -5px;
    display: block;
    content: '';
    width: 90px;
    height: 12px;
    background-color: ${({theme}) => theme.color.blue};
    z-index: -1;
  }
  
    ${({theme}) => theme.media.phone} {
    font-size: 28px;
    
    span::before {
      width: 85px;
    }
  }
`

const Paragraph = styled.p`
  font-weight: ${({theme}) => theme.font.regular};
  font-size: 18px;
  color: ${({theme}) => theme.color.black};
  margin: 0 0 10px 0;
  
  span {
    font-weight: ${({theme}) => theme.font.semiBold};
  }
  
  ${({theme}) => theme.media.phone} {
    font-size: 16px;
  }
`

export default About
